import { createContext, useContext } from "react";

type NavbarContextResults = {
  customTitle?: string;
  setCustomTitle: (title?: string) => void;
};

export const NavbarContext = createContext<NavbarContextResults>(
  {} as NavbarContextResults,
);

export const useNavbarContext = () => useContext(NavbarContext);
